import { Component, inject } from '@angular/core';
import { MainLayout } from './layout/components/main-layout/main-layout';
import { ThemeService } from '@mlc/shared/theme-toggle/theme.service';
import { RibbonComponent } from '@mlc/shared//ribbon/ribbon.component';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [MainLayout, RibbonComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private themeService = inject(ThemeService); // Eagerly initialize theme service
  environment = environment;
}
